//React applications need environment variables to start with REACT_APP
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080'


// WEBPACK FOOTER //
// ./src/constants/constants.js